import { api } from "shared/redux/api";
import { objectToQueryString } from "shared/utils/common";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    CreateGeneralTask: build.mutation({
      query: (arg) => ({
        url: "/private/general-task/v1",
        method: "POST",
        body: arg,
      }),
    }),
    GetGeneralTasks: build.query({
      query: (arg) => {
        return {
          url: `/private/general-task/v1${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        };
      },
    }),
    GetDetailGeneralTask: build.query({
      query: (arg) => {
        return {
          url: `/private/general-task/v1/${arg}`,
        };
      },
    }),
    UpdateGeneralTask: build.mutation({
      query: ({ id, ...res }) => ({
        url: `/private/general-task/v1/${id}`,
        method: "PUT",
        body: res,
      }),
    }),
    DeleteGeneralTask: build.mutation({
      query: (arg) => ({
        url: `/private/general-task/v1/${arg.id}`,
        method: "DELETE",
      }),
    }),
    TriggerCreateSubTask: build.mutation({
      query: (id) => ({
        url: `/private/general-task/v1/${id}/trigger-create-task`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateGeneralTaskMutation,
  useLazyGetGeneralTasksQuery,
  useGetDetailGeneralTaskQuery,
  useUpdateGeneralTaskMutation,
  useDeleteGeneralTaskMutation,
  useTriggerCreateSubTaskMutation,
} = injectedRtkApi;
